<template>
	<div class="view-user-list">
		<section class="grid" v-if="userCollection.length > 0">
			<ChalkyUserCardPreview
				class="list-item"
				v-bind:key="userModel.id"
				v-bind:userModel="userModel"
				v-for="userModel in userCollection"
				v-on:click.native="Handle_OnClickUser($event, userModel)"
			/>
		</section>

		<section v-else-if="emptyState === 'loading'">
			<ViewUiStateLoader />
		</section>
	</div>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * User list/grid component with support for different empty states.
	 *
	 * Displays a grid of user cards and handles empty state rendering
	 * for loading scenarios.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/User
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUserList extends ViewBase {
		/**
		 * The empty state to display when collection is empty.
		 *
		 * @type string
		 */
		@Prop({ default: 'loading' })
		public emptyState!: 'loading' | 'none';

		/**
		 * Collection of users to display.
		 *
		 * @type ChalkySticks.Collection.User
		 */
		@Prop({ required: true })
		public userCollection!: ChalkySticks.Collection.User;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle user card click.
		 *
		 * @param PointerEvent e
		 * @param ChalkySticks.Model.User userModel
		 * @return void
		 */
		protected Handle_OnClickUser(e: PointerEvent, userModel: ChalkySticks.Model.User): void {
			this.$emit('user:select', e, userModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-user-list {
		.grid {
			background: var(--chalky-blue-2);
			border-radius: 0.5rem;
			display: flex;
			flex-wrap: wrap;
			gap: 1rem;
			margin-left: -0.25rem;
			margin-right: -0.25rem;
			padding: 0.75rem;

			.user-cardpreview {
				.content {
					--padding: 1rem;
				}

				.actions {
					display: none;
				}

				.name {
					max-width: 100%;
				}

				.utility-dots {
					display: none;
				}
			}
		}
	}
</style>
